const random = () => Math.random();
const isObject = (val) => typeof val === "object" && val !== null;
const asObjectOrDefault = (val, defaultValue) => isObject(val) ? val : defaultValue;
function camelcasify(value) {
  const [[firstChar, ...firstRest], ...rest] = value.split(/[-_]/g);
  return firstChar.toLowerCase().concat(
    ...firstRest,
    ...rest.flatMap(([firstCharOfRest, ...restOfTheRest]) => [
      firstCharOfRest.toUpperCase(),
      ...restOfTheRest
    ])
  );
}
export {
  asObjectOrDefault,
  camelcasify,
  isObject,
  random
};
